export const services = [
  {
    id: 'cirurgia-bucomaxilofacial',
    title: 'Cirurgia Bucomaxilofacial',
    slug: '/servicos/cirurgia-bucomaxilofacial',
    shortDescription: 'Procedimentos cirúrgicos avançados para correção de problemas ósseos, articulares e patologias da face, mandíbula e maxilar.',
    fullDescription: 'A cirurgia bucomaxilofacial é uma especialidade odontológica que atua no diagnóstico e tratamento cirúrgico de doenças, traumatismos e anomalias da boca, face e região maxilofacial. Com técnicas minimamente invasivas e tecnologia 3D para planejamento, garantimos resultados precisos e recuperação acelerada.',
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/ac4a1371-0430-4601-89d2-34c8080df838_compressed_IMG_3668.webp',
    icon: 'ri-mental-health-line',
    featured: true,
    benefits: [
      'Planejamento cirúrgico 3D personalizado',
      'Técnicas minimamente invasivas',
      'Recuperação mais rápida e confortável',
      'Anestesia e sedação para máximo conforto',
    ],
  },
  {
    id: 'extracao-de-siso',
    title: 'Extração de Siso',
    slug: '/servicos/extracao-de-siso',
    shortDescription: 'Remoção cirúrgica dos terceiros molares com técnica atraumática, sedação consciente e recuperação acelerada.',
    fullDescription: 'A extração dos dentes do siso é um dos procedimentos mais comuns na odontologia. Quando não há espaço suficiente para a erupção adequada, os sisos podem causar dores, infecções e até desalinhamento dos demais dentes. Realizamos o procedimento com sedação consciente e técnica minimamente traumática.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20dental%20wisdom%20tooth%20clinical%20photography%2C%20impacted%20third%20molar%20on%20clean%20white%20background%2C%20dental%20anatomy%20study%2C%20soft%20clinical%20lighting%2C%20minimalist%20medical%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20professional%20dental%20education%20concept%2C%20tooth%20nerve%20and%20root%20detail%2C%20sterile%20healthcare%20aesthetic&width=800&height=600&seq=siso-dente-01&orientation=landscape',
    icon: 'ri-tooth-line',
    featured: false,
    benefits: [
      'Sedação consciente para zero dor',
      'Técnica atraumática com recuperação em 48h',
      'Avaliação com tomografia 3D',
      'Acompanhamento pós-operatório completo',
    ],
  },
  {
    id: 'invisalign',
    title: 'Invisalign',
    slug: '/servicos/invisalign',
    shortDescription: 'Alinhadores transparentes e removíveis para correção ortodôntica discreta e confortável com tecnologia digital 3D.',
    fullDescription: 'O Invisalign é o sistema de alinhadores ortodônticos mais avançado do mundo. Totalmente transparentes e removíveis, os alinhadores corrigem o posicionamento dos dentes de forma discreta e confortável. Com planejamento digital ClinCheck, você visualiza o resultado final antes mesmo de começar o tratamento.',
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/bf560c08-abb5-42ed-9124-aa54ac54ecbb_compressed_3232323sdcfd.webp',
    icon: 'ri-emotion-happy-line',
    featured: true,
    benefits: [
      'Alinhadores 100% transparentes e removíveis',
      'Planejamento digital ClinCheck 3D',
      'Tratamento personalizado por etapa',
      'Resultado previsível e comprovado',
    ],
  },
  {
    id: 'odontopediatria',
    title: 'Odontopediatria',
    slug: '/servicos/odontopediatria',
    shortDescription: 'Atendimento odontológico especializado para crianças e adolescentes com abordagem lúdica, acolhedora e preventiva.',
    fullDescription: 'A odontopediatria é a especialidade dedicada à saúde bucal de bebês, crianças e adolescentes. Nosso atendimento é conduzido com técnicas de manejo comportamental, ambiente acolhedor e linguagem adaptada para cada idade, criando uma relação positiva com o dentista desde a primeira infância.',
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/83aa6f98-8cea-4041-bb9f-aac526348fea_compressed_ChatGPT-Image-23-de-jul.-de-2026-22_10_03.webp',
    imagePosition: 'object-[50%_15%]',
    icon: 'ri-heart-line',
    featured: false,
    benefits: [
      'Ambiente lúdico e acolhedor',
      'Técnicas de manejo comportamental',
      'Foco em prevenção e educação',
      'Acompanhamento do crescimento facial',
    ],
  },
  {
    id: 'clareamento-dental',
    title: 'Clareamento Dental',
    slug: '/servicos/clareamento-dental',
    shortDescription: 'Clareamento profissional com tecnologia LED e gel de última geração para dentes até 8 tons mais brancos em sessão única.',
    fullDescription: 'O clareamento dental profissional é o procedimento estético mais rápido e seguro para transformar seu sorriso. Utilizamos gel clareador de alta concentração ativado por LED, proporcionando resultados visíveis já na primeira sessão. Protocolo personalizado conforme a sensibilidade e objetivo de cada paciente.',
    image: 'https://public.readdy.ai/ai/img_res/edited_ac53cf9b9e36486e1c690cda7b34df19_9576f56e.jpg',
    imagePosition: 'object-[50%_58%]',
    icon: 'ri-sun-line',
    featured: false,
    benefits: [
      'Resultado de até 8 tons mais claros',
      'Protocolo personalizado por sensibilidade',
      'Tecnologia LED de última geração',
      'Sessão única ou tratamento combinado',
    ],
  },
  {
    id: 'implantes-dentarios',
    title: 'Implantes Dentários',
    slug: '/servicos/implantes-dentarios',
    shortDescription: 'Implantes de titânio de última geração com técnica minimamente invasiva, planejamento 3D e resultados naturais duradouros.',
    fullDescription: 'Os implantes dentários são a solução mais moderna e definitiva para a perda de dentes. Utilizamos implantes de titânio de última geração com superfície tratada para osteointegração acelerada. Todo o procedimento é planejado digitalmente em 3D, garantindo precisão milimétrica e recuperação confortável.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20dental%20implant%20model%20on%20clean%20white%20surface%20with%20soft%20shadows%2C%20professional%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20titanium%20implant%20with%20crown%2C%20elegant%20healthcare%20aesthetic%2C%20warm%20beige%20background%2C%20clean%20composition&width=800&height=600&seq=implantes-01&orientation=landscape',
    icon: 'ri-check-double-line',
    featured: true,
    benefits: [
      'Planejamento cirúrgico 3D digital',
      'Implantes de titânio grau médico',
      'Técnica minimamente invasiva',
      'Garantia e durabilidade comprovada',
    ],
  },
  {
    id: 'facetas',
    title: 'Facetas Dentárias',
    slug: '/servicos/facetas',
    shortDescription: 'Facetas em porcelana de alta resistência para transformação estética do sorriso com resultado natural, harmônico e duradouro.',
    fullDescription: 'As facetas dentárias em porcelana são lâminas ultrafinas (0,2mm a 0,4mm) aplicadas sobre a superfície dos dentes para corrigir cor, forma, tamanho e alinhamento. O resultado é um sorriso perfeitamente harmônico e natural. Trabalhamos com as melhores cerâmicas do mercado e planejamento digital do sorriso.',
    image: 'https://public.readdy.ai/ai/img_res/edited_62d654f154e5a1a02c37af001b376ea0_4a65d029.jpg',
    icon: 'ri-sparkling-line',
    featured: true,
    benefits: [
      'Porcelana de alta resistência e estética',
      'Planejamento digital do sorriso (DSD)',
      'Mockup para visualização prévia',
      'Resultado natural e personalizado',
    ],
  },
  {
    id: 'avaliacao-odontologica',
    title: 'Avaliação Odontológica',
    slug: '/servicos/avaliacao-odontologica',
    shortDescription: 'Check-up odontológico completo com tecnologia de diagnóstico avançada e plano de tratamento personalizado para sua saúde bucal.',
    fullDescription: 'A avaliação odontológica completa é o primeiro passo para uma saúde bucal de excelência. Em uma consulta detalhada, realizamos exame clínico, radiografias, fotos intraorais e planejamento individualizado. Você recebe um diagnóstico completo e um plano de tratamento personalizado alinhado aos seus objetivos.',
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/5c9eef4f-b06c-4fe4-8569-02e242b7ac85_compressed_IMG_5316-22221.webp',
    icon: 'ri-search-eye-line',
    featured: false,
    benefits: [
      'Check-up completo com tecnologia digital',
      'Diagnóstico preciso com imagens 3D',
      'Plano de tratamento personalizado',
      'Prevenção e detecção precoce',
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Jonathan',
    age: 21,
    procedure: 'Retirada do Aparelho + Limpeza',
    text: 'Fiz a retirada do meu aparelho fixo com a Dra. Marihana e também a limpeza pós-tratamento. Além de todo o cuidado durante o processo, ela me orientou sobre os cuidados essenciais depois da retirada e fez uma avaliação completa da saúde bucal. O resultado ficou perfeito — sorriso alinhado e saudável. Super recomendo!',
    platform: 'Google Reviews',
    rating: 5,
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/89c6a9ed-c88c-4768-a0c3-7dd32ad0226d_compressed_IMG_3278.webp',
  },
  {
    id: 2,
    name: 'Rafael Mendes',
    age: 42,
    procedure: 'Implantes Dentários',
    text: 'Coloquei dois implantes com a Dra. Marihana e a experiência foi muito melhor do que eu imaginava. O planejamento 3D me deixou seguro, o procedimento foi tranquilo, sem dor, e o resultado ficou perfeito. Parece dente natural. Profissional extremamente cuidadosa e atenciosa em cada detalhe.',
    platform: 'Google Reviews',
    rating: 5,
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/35e23230-3903-48b7-bdc3-3c4310ed906d_compressed_ChatGPT-Image-20-de-jul.-de-2026-22_24_13.webp',
  },
  {
    id: 3,
    name: 'Juliana Costa',
    age: 39,
    procedure: 'Clareamento Dental + Restaurações',
    text: 'Fiz clareamento e restaurações estéticas com a Dra. Marihana. O cuidado que ela tem com cada detalhe é impressionante. Meu sorriso ficou natural e luminoso, exatamente como eu queria. Além disso, o consultório é lindo e super acolhedor. Recomendo de olhos fechados.',
    platform: 'Google Reviews',
    rating: 5,
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/19c90852-1e55-4c20-bbbd-057ea62123a8_compressed_ChatGPT-Image-20-de-jul.-de-2026-22_35_30.webp',
  },
  {
    id: 4,
    name: 'Isabela M.',
    age: 11,
    procedure: 'Odontopediatria',
    text: 'Eu tinha muito medo de dentista, mas a Dra. Marihana é super legal! Ela explica tudo de um jeito divertido e o consultório tem brinquedos. Agora eu até gosto de ir lá. Minha mãe fica mais tranquila porque eu não choro mais.',
    platform: 'Google Reviews',
    rating: 5,
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/e11130fd-09ca-4b6f-a25b-b151e32c5b80_compressed_NIna.webp',
  },
];

export const aboutData = {
  name: 'Dra. Marihana Pasquali',
  title: 'Cirurgiã Dentista',
  cro: 'CRO-SP 172094',
  shortBio: 'Há mais de 12 anos transformando sorrisos e devolvendo a confiança de meus pacientes na região da Faria Lima. Especialista em cirurgia bucomaxilofacial, estética dental e reabilitação oral.',
  description: 'Formada pela Faculdade Serra Gaúcha, no Sul do Brasil, a Dra. Marihana Pasquali acumula mais de 4 anos de experiência clínica e já atendeu mais de 1000 pacientes em sua trajetória. Atualmente, está em especialização em Cirurgia Bucomaxilofacial pela renomada São Leopoldo Mandic — Campinas, uma das mais respeitadas instituições de odontologia do país. Integra a equipe de cirurgia do Hospital Santa Paula, onde atua em procedimentos cirúrgicos de alta complexidade. Sua formação contínua, experiência clínica e atuação em ambiente hospitalar proporcionam uma abordagem cuidadosa, técnica e individualizada em cada tratamento.',
  extendedBio: 'Acredito que cada sorriso conta uma história única — e meu trabalho é garantir que essa história seja contada com confiança, saúde e beleza. No consultório, cada paciente recebe atenção integral: desde a primeira avaliação até o acompanhamento pós-tratamento. Utilizo tecnologias como scanner intraoral 3D, tomografia computadorizada, planejamento cirúrgico digital e sedação consciente para proporcionar a melhor experiência possível.',
  philosophy: 'Odontologia de excelência não é apenas sobre técnica — é sobre entender o que cada paciente realmente precisa e entregar muito além do esperado.',
  image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/f075322b-f3ac-4364-a5fe-73fa28de4de4_compressed_DSC07751---Copia---Copia.webp',
  stats: [
    { value: '4+', label: 'Anos de Experiência' },
    { value: '1000+', label: 'Pacientes' },
    { value: 'Santa Paula', label: 'Equipe Cirúrgica Hospitalar' },
    { value: '4.9', label: 'Avaliação Google' },
  ],
};

export const differentiators = [
  {
    icon: 'ri-qr-scan-line',
    title: 'Tecnologia 3D de Ponta',
    description: 'Scanner intraoral, tomografia e planejamento digital para diagnósticos precisos e resultados previsíveis.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Atendimento Humanizado',
    description: 'Cada paciente é único. Tratamento personalizado com escuta ativa, empatia e cuidado em cada detalhe.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Excelência e Segurança',
    description: 'Protocolos rigorosos de biossegurança, materiais de primeira linha e técnicas minimamente invasivas.',
  },
  {
    icon: 'ri-time-line',
    title: 'Agilidade sem Pressa',
    description: 'Respeitamos seu tempo com pontualidade, mas dedicamos o tempo necessário para cada atendimento.',
  },
];

export const patientJourney = [
  {
    step: '01',
    title: 'Agendamento',
    description: 'Escolha o melhor horário por WhatsApp, telefone ou formulário. Respondemos em até 15 minutos.',
    icon: 'ri-calendar-check-line',
  },
  {
    step: '02',
    title: 'Primeira Consulta',
    description: 'Avaliação completa com exames de imagem 3D, fotos intraorais e escuta detalhada das suas expectativas.',
    icon: 'ri-search-eye-line',
  },
  {
    step: '03',
    title: 'Plano Personalizado',
    description: 'Apresentamos o diagnóstico e o plano de tratamento personalizado com simulação digital do resultado.',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '04',
    title: 'Tratamento',
    description: 'Execução com tecnologia de ponta, sedação quando necessário e acompanhamento a cada etapa.',
    icon: 'ri-tooth-line',
  },
  {
    step: '05',
    title: 'Acompanhamento',
    description: 'Manutenção periódica e suporte contínuo para garantir a longevidade e saúde do seu sorriso.',
    icon: 'ri-heart-pulse-line',
  },
];

export const faqItems = [
  {
    category: 'Extração de Siso',
    question: 'A extração de siso dói durante o procedimento?',
    answer: 'Não. A Dra. Marihana realiza a extração de siso sob anestesia local potente e, quando necessário, sedação consciente — você fica completamente relaxado e não sente absolutamente nada durante a cirurgia. No pós-operatório, o desconforto é mínimo e controlado com medicação prescrita. O protocolo de dor zero é um dos diferenciais que fazem os pacientes recomendarem a Dra. Marihana.',
  },
  {
    category: 'Extração de Siso',
    question: 'Quanto tempo dura a cirurgia de extração de siso?',
    answer: 'O tempo varia conforme a complexidade do caso. Um siso já erupcionado pode ser removido em 20 a 30 minutos. Sisos inclusos ou impactados podem levar de 40 a 60 minutos. Durante a consulta de avaliação com tomografia 3D, a Dra. Marihana explica exatamente o tempo estimado e cada etapa do procedimento, para que você chegue no dia da cirurgia totalmente seguro e informado.',
  },
  {
    category: 'Extração de Siso',
    question: 'Quanto tempo de repouso após extrair o siso?',
    answer: 'Com a técnica atraumática utilizada pela Dra. Marihana, a maioria dos pacientes retorna às atividades normais em 48 horas. Nos primeiros 3 dias, recomenda-se repouso relativo — evitar exercícios físicos intensos. O inchaço atinge o pico em 48h e regride nos dias seguintes. Todo paciente recebe uma cartilha digital de cuidados pós-operatórios e tem acesso direto à Dra. Marihana pelo WhatsApp para qualquer dúvida durante a recuperação.',
  },
  {
    category: 'Extração de Siso',
    question: 'A Dra. Marihana extrai os 4 sisos de uma vez?',
    answer: 'Sim, é possível extrair os 4 sisos em uma única sessão cirúrgica — e essa é inclusive a recomendação para muitos pacientes, pois reduz o número de recuperações. A Dra. Marihana avalia cada caso individualmente com tomografia 3D e define a melhor estratégia. Em situações de sisos muito complexos, pode-se optar por fazer dois de cada lado, com intervalo entre as sessões, sempre priorizando sua segurança e conforto.',
  },
  {
    category: 'Cirurgia Bucomaxilofacial',
    question: 'A cirurgia bucomaxilofacial é realizada com anestesia geral?',
    answer: 'A maioria dos procedimentos é realizada sob anestesia local com sedação consciente, proporcionando conforto total sem os riscos da anestesia geral. Para cirurgias mais complexas, como a ortognática, trabalhamos com uma equipe de anestesiologistas em ambiente hospitalar. Cada caso é avaliado individualmente para determinar a melhor abordagem.',
  },
  {
    category: 'Invisalign',
    question: 'Invisalign dói? Qual a diferença para o aparelho fixo?',
    answer: 'O Invisalign é significativamente mais confortável que o aparelho fixo. Você pode sentir uma leve pressão nos primeiros dias de cada troca de alinhador — isso significa que os dentes estão se movendo. Não há fios soltando, bráquetes machucando a bochecha, nem restrições alimentares. É uma experiência completamente diferente e muito mais confortável.',
  },
  {
    category: 'Odontopediatria',
    question: 'Com que idade devo levar meu filho ao dentista pela primeira vez?',
    answer: 'A recomendação é que a primeira consulta aconteça por volta dos 6 meses de idade, quando os primeiros dentinhos começam a aparecer. Essa consulta é focada em orientar os pais sobre higiene bucal, aleitamento, uso de mamadeira e prevenção de cáries. É um momento educativo que estabelece uma relação positiva desde cedo.',
  },
  {
    category: 'Clareamento Dental',
    question: 'Quanto tempo dura o resultado do clareamento?',
    answer: 'A duração do clareamento varia de 1 a 3 anos, dependendo dos seus hábitos: consumo de café, vinho, chá, tabagismo e higiene bucal influenciam diretamente. O protocolo combinado (consultório + caseiro) oferece maior longevidade. Recomendamos manutenções anuais para manter o sorriso sempre luminoso.',
  },
  {
    category: 'Implantes Dentários',
    question: 'Qual a durabilidade de um implante dentário?',
    answer: 'Implantes dentários bem planejados, instalados com técnica adequada e mantidos com boa higiene podem durar 20, 30 anos ou até a vida toda. A chave está na qualidade do planejamento, precisão cirúrgica e manutenção periódica. Trabalhamos apenas com implantes de titânio grau médico das melhores marcas, com garantia e comprovação científica de longo prazo.',
  },
  {
    category: 'Facetas Dentárias',
    question: 'Facetas dentárias desgastam os dentes naturais?',
    answer: 'O desgaste é mínimo — entre 0,2mm e 0,5mm, ou seja, a espessura de uma unha. Em muitos casos, fazemos lentes de contato dental sem desgaste algum. A quantidade removida é drasticamente menor que nas coroas tradicionais, e o dente permanece vital. Trabalhamos com microscópio e lupa de aumento para máxima precisão no preparo.',
  },
  {
    category: 'Avaliação Odontológica',
    question: 'Com que frequência devo fazer o check-up odontológico?',
    answer: 'Recomendamos check-up a cada 6 meses para a maioria dos pacientes. Pacientes com histórico de doença periodontal, fumantes, diabéticos e gestantes podem precisar de intervalos menores (3 a 4 meses). Na avaliação, definimos a frequência ideal para seu caso específico e montamos um cronograma de retornos.',
  },
];

export const galleryImages = [
  {
    id: 1,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/fc627285-ca8d-4e77-9a96-30d413f0d0e8_compressed_ChatGPT-Image-20-de-jul.-de-2026-22_18_53.webp',
    alt: 'Dra. Marihana Pasquali e Dra. Salomão Cunha no consultório odontológico - profissionais de jaleco branco',
  },
  {
    id: 2,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/07a7ae0a-bcd6-4998-ad3c-f94d26cc2b90_compressed_IMG_3651.JPG.webp',
    alt: 'Brinquedoteca acolhedora para crianças no consultório',
  },
  {
    id: 3,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/d77f738a-63b8-45c7-a6b8-248622055ab1_compressed_IMG_3675.webp',
    alt: 'Sala de atendimento com equipamentos modernos',
  },
  {
    id: 4,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/68d04e21-06fa-4fcc-9843-4bde56ceae59_compressed_IMG_3525.webp',
    alt: 'Parede decorada do consultório de odontopediatria',
  },
  {
    id: 5,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/525aab4d-9254-404d-accb-893c2f90cd5c_compressed_IMG_3517---Copia.webp',
    alt: 'Dra. Marihana Pasquali na recepção do consultório',
  },
  {
    id: 6,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/a72a81f2-9ef3-4816-8bcf-c37d06f138fb_compressed_IMG_3524.webp',
    alt: 'Consultório de odontopediatria com ambiente lúdico e acolhedor',
  },
  {
    id: 7,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/6251e436-a5f4-4143-8003-0eb9b0dc4f23_compressed_IMG_3641.JPG.webp',
    alt: 'Recepção do consultório odontológico Salomão Cunha - ambiente acolhedor e sofisticado',
  },
  {
    id: 8,
    src: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/0dc8b2bb-a8ea-490b-8aeb-a3d916540d58_compressed_IMG_3613.JPG.webp',
    alt: 'Consultório odontológico com vista para a cidade',
  },
];

export const ctaData = {
  title: 'Seu sorriso dos sonhos começa com uma conversa.',
  subtitle: 'Agende sua avaliação personalizada e descubra o tratamento ideal para você. Atendimento premium na Faria Lima.',
  buttonText: 'Agendar Minha Avaliação',
};

export const contactInfo = {
  phone: '(11) 92694-1046',
  email: 'marihanapasquali@outlook.com',
  address: 'Av. Brigadeiro Faria Lima, 2355 - 6º andar - São Paulo',
  whatsapp: '5511926941046',
  instagram: '@dramarihanapasquali',
  googleMapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.2!2d-46.6847!3d-23.5832!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sAv.%20Brigadeiro%20Faria%20Lima%2C%202355%20-%20S%C3%A3o%20Paulo!5e0!3m2!1spt-BR!2sbr!4v1690000000000',
};

export const blogPosts = [
  {
    id: 1,
    title: 'Lentes de Contato Dental: Tudo o Que Você Precisa Saber',
    excerpt: 'Descubra como as lentes de contato dental podem transformar seu sorriso em poucas sessões.',
    category: 'Estética Dental',
    date: '10 de Junho, 2026',
    readTime: '8 min de leitura',
    image: 'https://readdy.ai/api/search-image?query=Dental%20veneer%20smile%20transformation%2C%20clean%20white%20aesthetic%2C%20dental%20clinic%20photography%2C%20elegant%20minimalist%20style&width=600&height=750&seq=blog-01&orientation=portrait',
  },
  {
    id: 2,
    title: 'Implante Dentário Dói? Mitos e Verdades Sobre o Procedimento',
    excerpt: 'Esclarecemos os principais mitos sobre implantes e mostramos como a tecnologia tornou o procedimento confortável.',
    category: 'Implantes',
    date: '28 de Maio, 2026',
    readTime: '6 min de leitura',
    image: 'https://readdy.ai/api/search-image?query=Dental%20implant%20model%20clean%20clinical%20aesthetic%2C%20soft%20studio%20lighting%2C%20professional%20dental%20photography&width=600&height=750&seq=blog-02&orientation=portrait',
  },
  {
    id: 3,
    title: 'Clareamento Dental Profissional vs. Caseiro: Qual a Diferença?',
    excerpt: 'Entenda por que o clareamento profissional oferece resultados mais seguros, rápidos e duradouros.',
    category: 'Estética Dental',
    date: '15 de Maio, 2026',
    readTime: '5 min de leitura',
    image: 'https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/84184c95-d1f2-4ad9-8902-de70197641fa_compressed_DSC07727-1.webp',
  },
  {
    id: 4,
    title: 'Saúde Bucal e Autoestima: O Impacto do Sorriso na Sua Vida',
    excerpt: 'Descubra como cuidar da saúde bucal impacta positivamente sua confiança e vida social.',
    category: 'Saúde Bucal',
    date: '02 de Maio, 2026',
    readTime: '7 min de leitura',
    image: 'https://readdy.ai/api/search-image?query=Happy%20woman%20with%20beautiful%20natural%20smile%2C%20warm%20sunlight%2C%20lifestyle%20photography&width=600&height=750&seq=blog-04&orientation=portrait',
  },
];